import { useMutation, useQueryClient } from '@tanstack/react-query'
import { commitSimulation, fetchSimulationPreview, fetchSimulationQuickFill } from './simulationApi'
import type {
  ReinvestSuggestion,
  SimulationCommitResponse,
  SimulationInput,
  SimulationResult,
} from '@/types/simulation'

export function useWhatIfPreview() {
  return useMutation<SimulationResult, Error, SimulationInput>({
    mutationFn: fetchSimulationPreview,
  })
}

export function useWhatIfQuickFill() {
  return useMutation<ReinvestSuggestion[], Error, { sell_position_id: number; amount_eur: string }>(
    {
      mutationFn: fetchSimulationQuickFill,
    },
  )
}

export function useWhatIfCommitMutation() {
  const qc = useQueryClient()
  return useMutation<SimulationCommitResponse, Error, SimulationInput>({
    mutationFn: commitSimulation,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['orderTickets'] })
      qc.invalidateQueries({ queryKey: ['positions'] })
    },
  })
}
